module.exports = __webpack_public_path__ + "static/media/crossIcon.a21256a8.svg";